import script from "./psiShopInGoodsOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./psiShopInGoodsOrder.vue?vue&type=script&setup=true&lang=js"

import "./psiShopInGoodsOrder.vue?vue&type=style&index=0&id=5238b5d7&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5238b5d7"]])

export default __exports__